import { readSaved, save, savedScore } from './storage.js';

const games = [...document.querySelectorAll('[data-game]')];
function refreshScores() {
  document.querySelectorAll('[data-score]').forEach(el => {
    el.textContent = `Your best: ${savedScore(el.dataset.score).toLocaleString()}`;
  });
  const last = games.find(game => game.dataset.game === readSaved('arcade-last-game'));
  const link = document.getElementById('last-game');
  if (last) { link.href = last.href; link.textContent = `Back to ${last.querySelector('strong').textContent}`; link.hidden = false; }
}
games.forEach(game => game.addEventListener('click', () => save('arcade-last-game', game.dataset.game)));
document.getElementById('random-game').onclick = () => games[Math.floor(Math.random() * games.length)].click();
window.addEventListener('pageshow', refreshScores);
refreshScores();

const sound = document.getElementById('site-sound');
const syncSound = () => {
  const muted = readSaved('site-muted') === 'true';
  sound.textContent = muted ? '🔇' : '🔊';
  sound.setAttribute('aria-pressed', String(muted));
  sound.setAttribute('aria-label', muted ? 'Unmute site sounds' : 'Mute site sounds');
  document.querySelectorAll('audio').forEach(audio => { audio.muted = muted; });
};
sound.onclick = () => { save('site-muted', readSaved('site-muted') !== 'true'); syncSound(); };
syncSound();

const headlines = [
  'Local man calls meeting that could have been a honk.',
  'Jim announces Lunch 2.0. Critics preferred the original.',
  'Nissan Versa named Jim’s car of the year. Again.',
  'Jim says “quick question.” Area productivity collapses.',
  'Study finds Jim is still the leading cause of Jim.',
  'Jim seen replying all. Investigation ongoing.',
  'Man with 47 browser tabs says your computer is slow.',
  'Jim’s five-minute story enters its third fiscal quarter.',
  'Local man describes parking job as “close enough.”',
  'Jim marks himself essential. Evidence remains inconclusive.',
];
const now = new Date();
const day = Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000);
document.getElementById('report-date').textContent = now.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
document.getElementById('daily-headline').textContent = headlines[day % headlines.length];
const excuses = [
  '“That sounds like a problem for Future Jim.”',
  '“The Versa would never do this to me.”',
  '“I was on lunch. The second one.”',
  '“In my defense, I thought reply-all meant all my friends.”',
  '“Have you tried lowering your expectations?”',
  '“I would like to speak to the webmaster.”',
];
let excuse = 0;
document.getElementById('excuse-btn').onclick = () => {
  document.getElementById('jim-excuse').textContent = excuses[excuse++ % excuses.length];
};

// User content always becomes text nodes, including entries loaded from storage.
let entries = [];
try {
  const stored = JSON.parse(readSaved('jim-guestbook', '[]'));
  if (Array.isArray(stored)) entries = stored.filter(e => typeof e.name === 'string' && typeof e.message === 'string').slice(0, 20);
} catch { /* A malformed local entry should never break the page. */ }
const list = document.getElementById('guestbook-entries');
function renderEntries() {
  list.replaceChildren();
  if (!entries.length) {
    const empty = document.createElement('li');
    empty.textContent = 'No signatures yet. Jim assumes this means universal approval.';
    list.append(empty);
  }
  entries.forEach((entry, index) => {
    const li = document.createElement('li');
    const name = document.createElement('strong');
    name.textContent = entry.name.slice(0, 32);
    const message = document.createElement('p');
    message.textContent = entry.message.slice(0, 240);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.textContent = 'Remove';
    remove.setAttribute('aria-label', `Remove entry by ${name.textContent}`);
    remove.onclick = () => { entries.splice(index, 1); save('jim-guestbook', JSON.stringify(entries)); renderEntries(); };
    li.append(name, message, remove);
    list.append(li);
  });
}
renderEntries();
document.getElementById('guestbook-form').onsubmit = e => {
  e.preventDefault();
  const name = document.getElementById('guest-name').value.trim();
  const message = document.getElementById('guest-message').value.trim();
  const status = document.getElementById('guestbook-status');
  if (!name || !message) { status.textContent = 'Add your name and a review first.'; return; }
  entries.unshift({ name: name.slice(0, 32), message: message.slice(0, 240) });
  entries = entries.slice(0, 20);
  const persisted = save('jim-guestbook', JSON.stringify(entries));
  renderEntries();
  document.getElementById('guest-message').value = '';
  status.textContent = persisted ? 'Signed. Saved in this browser. Jim’s approval rating remains unchanged.' : 'Signed for this visit. Your browser is blocking saved entries.';
};
